var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextOvalBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "13DAE7FA-5871-49FE-8387-71B02B7BA5FD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "News",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NewsCorp_Mobile_Widget_Welcome",
    transform: "translate(-244.000000, -194.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/arrow_inactive",
    transform: "translate(244.000000, 194.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/next_oval_btn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,44 C9.8497355,44 0,34.1502645 0,22 C0,9.8497355 9.8497355,0 22,0 C34.1502645,0 44,9.8497355 44,22 C44,34.1502645 34.1502645,44 22,44 Z M30.3703644,21.2073644 L24.9925867,15.8295867 C24.4198044,15.2568044 23.4911111,15.2568044 22.9183289,15.8295867 C22.3455467,16.4023689 22.3455467,17.3310622 22.9183289,17.9038444 L25.7924089,20.7777289 L14.6666667,20.7777289 C13.8566756,20.7777289 13.2,21.4344044 13.2,22.2443956 C13.2,23.0543867 13.8566756,23.7110622 14.6666667,23.7110622 L25.7924089,23.7110622 L22.9185244,26.5853378 C22.3457422,27.15812 22.3457422,28.0868133 22.9185244,28.6595956 C23.4913067,29.2323778 24.42,29.2323778 24.9927822,28.6595956 L30.37056,23.2818178 C30.9431467,22.70884 30.9431467,21.7801467 30.3703644,21.2073644 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextOvalBtn);
export default __webpack_public_path__ + "static/media/next_oval_btn.b89ffa79640c67f5564c25d52a2fe542.svg";
export { ForwardRef as ReactComponent };